import { groupByRoot, groupPreferencesByPageId } from './grouping';
import { filterMissingSubGroupName } from './serialize';

/**
 * Convert large array of flat Access Role Options
 * into an object of arrays for each GroupName.
 * Also attach preferences to their function by AccessRoleId.
 *
 * @param {array} data
 */
export const formatGroupData = data => {
  data = groupPreferencesByPageId(data);
  data = filterMissingSubGroupName(data);
  return groupByRoot(data);
};

export const formatRolesForSelect = (roles = []) => {
  return roles.map(role => ({
    text: role.Description,
    value: role.Id,
  }));
};



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/helpers/format.js